import { CheckSmallIcon, CircleIcon } from '../generated'
import { StackIcons } from '../StackIcons'
import type { PredefinedStackProps } from '../PredefinedStackProps'

export const CheckMarkIconStacked = ({ backgroundColor, mainColor, color, ...props }: PredefinedStackProps) => (
  <StackIcons variant="full" {...props}>
    <CircleIcon color={backgroundColor || color} />
    <CheckSmallIcon color={mainColor || color} />
  </StackIcons>
)
